import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api";
import PageViewer from "../builder/PageViewer";
import HeaderFooterLayout from "../layouts/HeaderFooterLayout";
import styles from "./ArticlePreview.module.css";

const ArticlePreview = () => {
    const { articleId } = useParams();
    const navigate = useNavigate()
    const [article, setArticle] = useState(null)

    const getArticle = async () => {
        try {
            let article = await api.get(`/admin/articles/${articleId}`)
            setArticle(article)

        }
        catch (e) {

            console.error(e)
            navigate("/404")
        }
    }
    useEffect(() => {
        getArticle()
    }, [articleId])

    useEffect(() => {
        window.scrollTo({
            top: 0,
        })

    }, [])

    return (
        <HeaderFooterLayout hideFooter>
            <div className={styles.container}>
                {article &&
                    <PageViewer page={article.content} />
                }
            </div>

        </HeaderFooterLayout>
    )
}

export default ArticlePreview
